import React, { useEffect, useState } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import styled from 'styled-components';
import Img from 'gatsby-image';

const MediaTitle = styled.div`
  display: flex;
  max-width: 100rem;
  width: 85%;
  margin: 0 auto 2rem;
  font-size: 1.1rem;
  letter-spacing: 0.05em;
`;

const Media = styled.div`
  display: none;
  margin: 10rem auto 0;

  @media (min-width: 800px) {
    display: block;
  }
`;

const ImageNumber = styled.p`
  margin: 5vw 0 2vw;
  font-size: 1.2rem;
  color: var(--green-dark);
`;

const Slider = styled.div`
  width: calc(
    (
      (${(props) => props.children.length} * (25vw)) +
        (${(props) => props.children.length - 1} * (8vw)) + ((100vw - 85%) / 2)
    )
  );
  display: grid;
  grid-template-columns: repeat(${(props) => props.children.length}, 1fr);
  grid-gap: 8vw;
  margin-left: calc((100vw - 85%) / 2);
  padding-right: calc((100vw - 85%) / 2);

  @media (min-width: 1180px) {
    width: calc(
      (
        (${(props) => props.children.length} * (25vw)) +
          (${(props) => props.children.length - 1} * (8vw)) +
          ((100vw - 100rem) / 2)
      )
    );
    margin-left: calc((100vw - 100rem) / 2);
    padding-right: calc((100vw - 100rem) / 2);
  }
`;

const StyledImg = styled(Img)`
  width: 25vw;
  min-height: 10vw;
  max-height: 40vw;
  cursor: pointer;
`;

const MediaSliderProgressWrap = styled.div`
  position: relative;
  width: 85%;
  max-width: 100rem;
  border-bottom: 1px solid var(--green-light);
  margin: 0 auto;
`;

const MediaSliderProgress = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: transparent;

  &[type='range']:focus {
    outline: none;
  }

  &[type='range'] {
    -webkit-appearance: none;
  }

  &[type='range']::-webkit-slider-thumb {
    height: 1px;
    width: 20rem;
    border-radius: 0px;
    background: black;
    -webkit-appearance: none;
  }

  &[type='range']::-moz-range-thumb {
    height: 1px;
    width: 20rem;
    border-radius: 0px;
    background: black;
    -webkit-appearance: none;
  }

  &[type='range']::-ms-thumb {
    height: 1px;
    width: 20rem;
    border-radius: 0px;
    background: black;
    -webkit-appearance: none;
  }
`;

const MediaSlider = ({ project, handleClick }) => {
  const [scrollValue, setScrollValue] = useState(0);
  const [windowWidth, setWindowWidth] = useState(0);
  const [mediaWidth, setMediaWidth] = useState(0);
  const [paddingRight, setPaddingRight] = useState(0);
  const scrollTotall = mediaWidth - windowWidth + paddingRight;
  const range = `${Math.round((scrollValue / scrollTotall) * 100)}`;

  useEffect(() => {});

  return (
    <Media
      ref={(el) => {
        if (!el) return;
        setWindowWidth(el.getBoundingClientRect().width);
      }}
    >
      <MediaTitle>
        {project.galleryName ? (
          <p className="uppercase bold">{project.galleryName}</p>
        ) : (
          <p className="uppercase bold">galleria</p>
        )}
        {project.images.length > 1 ? (
          <span>- {project.images.length} immagini</span>
        ) : (
          <span>- {project.images.length} immagine</span>
        )}
      </MediaTitle>
      <div>
        <MediaSliderProgressWrap>
          {scrollTotall < 0 ? null : (
            <MediaSliderProgress
              readOnly
              ariaHidden
              type="range"
              step=".001"
              min="0"
              max="100"
              value={range}
            />
          )}
        </MediaSliderProgressWrap>
        <ScrollContainer
          vertical={false}
          onScroll={(e) => {
            setScrollValue(e);
          }}
        >
          <Slider
            ref={(el) => {
              if (!el) return;
              setMediaWidth(el.getBoundingClientRect().width);
              setPaddingRight(
                parseInt(getComputedStyle(el).getPropertyValue('padding-right'))
              );
            }}
          >
            {project.images.map((image, index) => (
              <div
                key={index}
                onClick={() => handleClick(image)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleClick(image);
                  }
                }}
                role="button"
                tabIndex={0}
              >
                <ImageNumber>{`/ 0${index + 1}`}</ImageNumber>
                <StyledImg
                  project={project}
                  fluid={image.image.asset.fluid}
                  alt={image.alternativeText}
                />
              </div>
            ))}
          </Slider>
        </ScrollContainer>
      </div>
    </Media>
  );
};

export default MediaSlider;
